<div class="reservation-container">
    <div class="reservation-card">
        <!-- Success Message -->
        @if (successMessage) {
        <div class="alert-card-success">
            <div class="alert-title">Succès !</div>
            <div class="alert-text">{{ successMessage }}</div>
        </div>
        }

        <!-- Loading State -->
        @if (isLoading) {
        <div class="text-center py-8">
            <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <p class="mt-2 text-gray-600">{{ frenchTranslations.loadingForm }}</p>
        </div>
        }

        <!-- Header -->
        @if (!successMessage && !isLoading) {
        <div class="reservation-header">
            <h1>Demande de service de sécurité</h1>
            <h3>Planifiez facilement la sécurité de votre événement en quelques clics.</h3>
        </div>

        <!-- Error Message -->
        @if (errorMessage) {
        <div class="alert alert-error mt-3">
            <p class="form_error">{{ errorMessage }}</p>
        </div>
        }

        <!-- Reservation Form -->
        <form [formGroup]="reservationForm" (ngSubmit)="onSubmit()" class="space-y-6">
            <div class="form-section">
                <div class="form-row">
                    <div class="form-group name-group">
                        <input type="text" id="eventName" formControlName="eventName" [class.error]="hasError('eventName', 'required') || hasError('eventName', 'maxlength')" placeholder="Nom de l'événement (ex: Conférence annuelle, Cérémonie de mariage)" />                        @if (hasError('eventName', 'required')) {
                        <div class="form_error">
                            {{ getErrorMessage('eventName', 'required') }}
                        </div>
                        } @if (hasError('eventName', 'maxlength')) {
                        <div class="form_error">
                            {{ getErrorMessage('eventName', 'maxlength') }}
                        </div>
                        }
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div class="form-row">
                    <div class="form-group type-group ">
                        <select class="custom-select" id="reservationEventType" formControlName="reservationEventType" [class.error]="hasError('reservationEventType', 'required')">
                            <option value="" disabled selected>Sélectionnez le type d'événement</option>
                            @for (type of eventTypes; track type) {
                                <option [value]="type">{{ getEventTypeLabel(type) }}</option>
                            }
                        </select> @if (hasError('reservationEventType', 'required')) {
                        <div class="form_error">
                            {{ getErrorMessage('reservationEventType', 'required') }}
                        </div>
                        }
                    </div>
                </div>
            </div>

            <div class="form-section my-4">
                <label for="requiredAgents" class="label">Nombre d'agents requis* :</label>
                <div class="form-row">
                    <div class="form-group agents-group">
                        <div class="agents-input-container">
                            <input type="number" id="requiredAgents" formControlName="requiredAgents" [class.error]="hasError('requiredAgents', 'required') || hasError('requiredAgents', 'min') || hasError('requiredAgents', 'max')" min="1" max="50" readonly />
                        </div>
                        @if (hasError('requiredAgents', 'required')) {
                        <div class="form_error">
                            {{ getErrorMessage('requiredAgents', 'required') }}
                        </div>
                        } @if (hasError('requiredAgents', 'min')) {
                        <div class="form_error">
                            {{ getErrorMessage('requiredAgents', 'min') }}
                        </div>
                        } @if (hasError('requiredAgents', 'max')) {
                        <div class="form_error">
                            {{ getErrorMessage('requiredAgents', 'max') }}
                        </div>
                        }
                    </div>
                    <div class="agents-buttons">
                        <button type="button" class="agent-btn minus-btn" (click)="decrementAgents()" [disabled]="reservationForm.get('requiredAgents')?.value <= 1">
                            -
                        </button>
                        <button type="button" class="agent-btn plus-btn" (click)="incrementAgents()" [disabled]="reservationForm.get('requiredAgents')?.value >= 50">
                            +
                        </button>
                    </div>
                </div>
            </div>

            <div class="form-section">

                <div class="form-row">
                    <div class="label-row">
                        <label for="requiredAgents" class="label">Date de début de l'événement* :</label>
                        <div class="form-group date-group custom-date-input">
                            <input type="datetime-local" id="startDateTime" formControlName="startDateTime" [min]="minStartDate.toISOString().slice(0, 16)" [class.error]="hasError('startDateTime', 'required') || hasError('startDateTime', 'pastDate')" placeholder="Date et heure de début"
                            />
                            <label for="startDateTime" class="date-icon">
                                <img src="assets/images/icons/calendar.png" alt="Calendrier" class="date-icon-img">
                            </label>
                        </div>
                    </div>
                    <div class="label-row">
                        <label for="requiredAgents" class="label">Date de fin de l'événement* :</label>
                        <div class="form-group date-group custom-date-input">
                            <input type="datetime-local" id="endDateTime" formControlName="endDateTime" [min]="minEndDate.toISOString().slice(0, 16)" [class.error]="hasError('endDateTime', 'required') || hasError('endDateTime', 'pastDate') || hasError('endDateTime', 'dateSequence')"
                                placeholder="Date et heure de fin" />
                            <label for="endDateTime" class="date-icon">
                                <img src="assets/images/icons/calendar.png" alt="Calendrier" class="date-icon-img">
                            </label>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group date-group custom-date-input"> @if (hasError('startDateTime', 'required')) {
                        <div class="form_error">
                            {{ getErrorMessage('startDateTime', 'required') }}
                        </div>
                        } @if (hasError('startDateTime', 'pastDate')) {
                        <div class="form_error">
                            {{ getErrorMessage('startDateTime', 'pastDate') }}
                        </div>
                        }
                    </div>
                    <div class="form-group date-group custom-date-input">
                        @if (hasError('endDateTime', 'required')) {
                        <div class="form_error">
                            {{ getErrorMessage('endDateTime', 'required') }}
                        </div>
                        } @if (hasError('endDateTime', 'pastDate')) {
                        <div class="form_error">
                            {{ getErrorMessage('endDateTime', 'pastDate') }}
                        </div>
                        } @if (hasError('endDateTime', 'dateSequence')) {
                        <div class="form_error">
                            {{ getErrorMessage('endDateTime', 'dateSequence') }}
                        </div>
                        }
                    </div>
                </div>
            </div>

            <div class="form-section my-4">
                <div class="form-row">
                    <div class="form-group streetn-group" formGroupName="address">
                        <input type="text" id="streetNumber" formControlName="streetNumber" [class.error]="hasAddressError('streetNumber', 'maxlength')" placeholder="Numéro de rue"> @if (hasAddressError('streetNumber', 'maxlength')) {
                        <div class="form_error">
                            {{ getErrorMessage('streetNumber', 'maxlength') }}
                        </div>
                        }
                    </div>

                    <div class="form-group street-group" formGroupName="address">
                        <input type="text" id="street" formControlName="street" [class.error]="hasAddressError('street', 'required') || hasAddressError('street', 'maxlength')" placeholder="Nom de la rue"> @if (hasAddressError('street', 'required')) {
                        <div class="form_error">
                            {{ getErrorMessage('street', 'required') }}
                        </div>
                        } @if (hasAddressError('street', 'maxlength')) {
                        <div class="form_error">
                            {{ getErrorMessage('street', 'maxlength') }}
                        </div>
                        }
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group zip-group" formGroupName="address">
                        <input type="text" id="postalCode" formControlName="postalCode" [class.error]="hasAddressError('postalCode', 'required') || hasAddressError('postalCode', 'maxlength') || hasAddressError('postalCode', 'pattern')" placeholder="Code postal">                        @if (hasAddressError('postalCode', 'required')) {
                        <div class="form_error">
                            {{ getErrorMessage('postalCode', 'required') }}
                        </div>
                        } @if (hasAddressError('postalCode', 'maxlength')) {
                        <div class="form_error">
                            {{ getErrorMessage('postalCode', 'maxlength') }}
                        </div>
                        } @if (hasAddressError('postalCode', 'pattern')) {
                        <div class="form_error">
                            {{ getErrorMessage('postalCode', 'pattern') }}
                        </div>
                        }
                    </div>

                    <div class="form-group city-group" formGroupName="address">
                        <input type="text" id="city" formControlName="city" [class.error]="hasAddressError('city', 'required') || hasAddressError('city', 'maxlength')" placeholder="Ville"> @if (hasAddressError('city', 'required')) {
                        <div class="form_error">
                            {{ getErrorMessage('city', 'required') }}
                        </div>
                        } @if (hasAddressError('city', 'maxlength')) {
                        <div class="form_error">
                            {{ getErrorMessage('city', 'maxlength') }}
                        </div>
                        }
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div class="form-row">
                    <div class="form-group description-group">
                        <textarea id="description" formControlName="description" rows="4" [class.error]="hasError('description', 'maxlength')" placeholder="Veuillez fournir tout détail supplémentaire concernant votre événement, vos exigences particulières, etc."></textarea>                        @if (hasError('description', 'maxlength')) {
                        <div class="form_error">
                            {{ getErrorMessage('description', 'maxlength') }}
                        </div>
                        }
                        <div class="helper-text">
                            {{ f['description'].value?.length || 0 }}/1000 caractères
                        </div>
                    </div>
                </div>
            </div>

            <!-- Form Actions -->
            <div class="flex flex-col sm:flex-row gap-4 pt-6 border-t border-gray-200">
                <button type="submit" [disabled]="reservationForm.invalid || isSubmitting" class="btn register-btn" [class.loading]="isSubmitting">                   
                    {{ isSubmitting ? frenchTranslations.creatingReservation : frenchTranslations.confirm }}
                </button>
            </div>

        </form>
        }
    </div>

    <div class="image-col">
        <img src="assets/images/call-man.svg" alt="Security Call Center" class="login-image">
    </div>
</div>